import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => (
  <Box
    component="footer"
    sx={{
      width: '100%',
      py: 2,
      px: 3,
      bgcolor: 'primary.main', // Use a darker blue from theme
      color: 'primary.contrastText',
      borderRadius: 0,         // Remove rounded corners
      boxShadow: 1,
      mt: 'auto',
      textAlign: 'center',
    }}
  >
    <Typography variant="body2">
      &copy; {new Date().getFullYear()} Next Professional Services
    </Typography>
  </Box>
);

export default Footer;